<template>
  <div class="log">
    <button
      small
      type="button"
      @click="open()"
      v-if="
        section === 'assignmentList' &&
        assignDetails.isReadyForFinalPayment &&
        assignDetails.assignmentStatus != 4 &&
        assignDetails.assignmentStatus != 3
      "
      class="track-ass-btn green-button assignment-list-ready-doc-btn"
    >
      Edit
    </button>
    <v-btn
      @click="open()"
      v-if="
        section === 'jobDetails' &&
        assignDetails.isReadyForFinalPayment &&
        assignDetails.assignmentStatus != 4 &&
        assignDetails.assignmentStatus != 3
      "
      color="green darken-2"
      class="white--text ml-1"
      >Edit Ready To Pay & Doc Collected</v-btn
    >
    <!-- <button
      small
      type="button"
      @click="open()"
      v-if="
        section === 'jobDetails' &&
          assignDetails.isReadyForFinalPayment &&
          assignDetails.assignmentStatus != 4
      "
      class="track-ass-btn"
    >
      Edit Ready To Pay
    </button> -->

    <v-dialog
      v-model="dialog"
      max-width="46rem"
      persistent
      content-class="physical-doc-dialog"
    >
      <v-form
        ref="form"
        onsubmit="return false;"
        v-model="valid"
        lazy-validation
      >
        <v-card class="comments-view physical-doc-card">
          <header class="physical-doc-header">
            <div class="physical-doc-header__brand">
              <div class="physical-doc-header__badge" aria-hidden="true">
                <v-icon>description</v-icon>
              </div>
              <h2 class="physical-doc-title">
                Edit Document Collected & Final Payment Ready To Pay
              </h2>
            </div>
            <v-btn
              icon
              class="physical-doc-close"
              :disabled="processing"
              @click.prevent="close"
              title="Close"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </header>

          <v-progress-linear
            indeterminate
            color="trukkin-theme darken-2"
            v-show="processing"
          ></v-progress-linear>
          <div class="physical-doc-body">
            <!-- <div class="heading pl-4 pt-4">
            Have you collected the physical document from the driver ?
          </div> -->

            <div class="heading physical-doc-content">
              <v-layout>
                <v-flex xs12 md12>
                  Have you collected the physical document from the
                  {{ operatorRoleLabel }}?
                  <br />
                  <div class="labelheading">
                    <label>
                      If yes, fill {{ operatorRoleLabel.toLowerCase() }}
                      details, upload proof, enter date and time when it was
                      collected</label
                    >
                  </div>
                </v-flex></v-layout
              >
              <div class="physical-doc-credit">
                {{ operatorRoleLabel }}’s Payment credit period :
                <strong
                  >{{
                    driverCreditDuration && driverCreditDuration != 0
                      ? driverCreditDuration
                      : ""
                  }}
                  {{ driverCreditDuration ? "days" : "N.A" }}</strong
                >
              </div>
              <v-layout class="physical-doc-payment-summary">
                <v-flex xs4 md4 class="physical-doc-payment-summary__item">
                  <div class="sub-heading muted">
                    Total {{ operatorRoleLabel }} Price :
                    <span style="color: black" class="heading"
                      >{{
                        assignDetails.paymentAmount +
                        (assignDetails.totalAdditionalAmount
                          ? assignDetails.totalAdditionalAmount
                          : 0)
                      }}
                      {{ assignDetails.customerCurrency }}</span
                    >
                  </div>
                </v-flex>
                <v-flex xs4 md4 class="physical-doc-payment-summary__item">
                  <div class="sub-heading muted">
                    {{ operatorRoleLabel }} Price :
                    <span style="color: black" class="heading"
                      >{{ assignDetails.paymentAmount }}
                      {{ assignDetails.customerCurrency }}</span
                    >
                  </div>
                </v-flex>
                <v-flex xs4 md4 class="physical-doc-payment-summary__item">
                  <div class="sub-heading muted">
                    Additional Charges :
                    <span style="color: black" class="heading break-word">
                      {{ assignDetails.totalAdditionalAmount || "0" }}
                      {{ assignDetails.customerCurrency }}</span
                    >
                  </div>
                </v-flex>
              </v-layout>
              <v-layout class="physical-doc-payment-summary">
                <v-flex xs4 md4 class="physical-doc-payment-summary__item">
                  <div class="sub-heading muted break-word">
                    Advance Paid :
                    <span style="color: black" class="heading"
                      >{{ assignDetails.totalAdvancePaidAmount || "0" }}
                      {{ assignDetails.customerCurrency }}</span
                    >
                  </div>
                </v-flex>
                <v-flex xs4 md4 class="physical-doc-payment-summary__item">
                  <div class="sub-heading muted break-word">
                    Amount Paid Till Date:
                    <span style="color: black" class="heading"
                      >{{
                        Number(
                          Number(
                            (assignDetails.amountPaidToDriver
                              ? assignDetails.amountPaidToDriver
                              : 0) +
                              Number(
                                assignDetails.totalAdvancePaidAmount
                                  ? assignDetails.totalAdvancePaidAmount
                                  : 0
                              )
                          ).toFixed(2) || "0"
                        )
                      }}
                      {{ assignDetails.customerCurrency }}</span
                    >
                  </div>
                </v-flex>
                <v-flex xs4 md4 class="physical-doc-payment-summary__item">
                  <div class="sub-heading muted break-word">
                    Pending Amount :
                    <span style="color: black" class="heading"
                      >{{
                        assignDetails.paymentAmount -
                          assignDetails.totalAdvancePaidAmount -
                          assignDetails.amountPaidToDriver +
                          assignDetails.totalAdditionalAmount || "0"
                      }}
                      {{ assignDetails.customerCurrency }}</span
                    >
                  </div>
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex xs12>
                  <v-tabs
                    v-model="tabStatus"
                    fixed-tabs
                    background-color="#ea7a1c"
                    dark
                    class="main__tabs physical-doc-tabs"
                  >
                    <v-tab href="#Driver">
                      {{ operatorRoleLabel }} Payment Details
                    </v-tab>
                    <v-tab href="#Docs">
                      Edit {{ operatorRoleLabel }} Docs
                    </v-tab>
                  </v-tabs>
                </v-flex>
                <!-- <v-flex xs3 class="pr-1 pt-1 pb-3 pt-100">
                  <button
                    class="track-ass-btn blue-button"
                    flat
                    prepend-icon
                    color="white darken-1"
                    @click.stop="goToProof(assignDetails._id)"
                  >
                    Edit {{ operatorRoleLabel }} Docs
                  </button>
                </v-flex> -->
              </v-layout>

              <v-layout v-if="tabStatus === 'Driver'">
                <v-flex xs12>
                  <v-layout v-if="tabStatus === 'Driver'">
                    <v-flex xs12 md12>
                      <v-radio-group
                        class="mt-0 pt-0"
                        v-model="paymentMode"
                        row
                        :mandatory="true"
                        :rules="[rules.required]"
                      >
                        <div>
                          <div class>
                            <v-layout>
                              <v-radio
                                label="Cash"
                                value="Cash"
                                color="orange"
                                class="col-md-6"
                              ></v-radio>

                              <v-radio
                                label="Bank Transfer"
                                value="Bank Transfer"
                                color="orange"
                                class="col-md-6"
                              ></v-radio>
                              <!-- <v-radio
                            label="Demand Draft"
                            value="Demand Draft"
                            color="orange"
                            class="col-md-6"
                          ></v-radio>

                          <v-radio
                            label="Cheque"
                            value="Cheque"
                            color="orange"
                            class="col-md-6"
                          ></v-radio> -->
                            </v-layout>
                          </div>
                        </div>
                      </v-radio-group>
                      <!-- <v-select
                    :items="[
                      'Cash',
                      'Cheque',
                      'Demand Draft(DD)',
                      'Bank Transfer',
                    ]"
                    v-model="paymentMode"
                    class="pt-0 currencyTitle"
                    label="Mode of Payment"
                    placeholder="Mode of Payment"
                    :rules="[rules.required]"
                  /> -->
                    </v-flex>
                  </v-layout>
                  <v-layout
                    v-if="this.paymentMode == 'Cash'"
                    class="physical-doc-payment-fields"
                  >
                    <!-- <v-text-field
                    label="Voucher No."
                    placeholder="Enter Voucher No."
                    v-model="voucher"
                    class="pt-0 currencyTitle"
                    :rules="[rules.required, rules.noWhiteSpace]"
                  /> -->
                    <v-flex md6 class="payadvance physical-doc-field-col">
                      <v-flex md12>
                        <v-text-field
                          v-model="accountHolderName"
                          label="Account Holder Name"
                          placeholder="Enter account holder name"
                          class="pt-0 currencyTitle"
                          :value="accountHolderName"
                        ></v-text-field>
                      </v-flex>

                      <v-layout>
                        <v-flex md12 class="payadvance">
                          <v-text-field
                            v-model="ifscCode"
                            label="IBAN Number"
                            placeholder="Enter IBAN number"
                            class="pt-0 currencyTitle"
                            maxlength="25"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex md6 class="payadvance physical-doc-field-col">
                      <v-layout>
                        <v-flex md12 class="payadvance">
                          <v-text-field
                            v-model="accountNumber"
                            label="Account Number"
                            placeholder=" Enter Account Number"
                            class="pt-0 currencyTitle"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout>
                        <v-layout>
                          <v-flex md12 class="payadvance">
                            <v-text-field
                              v-model="swiftNumber"
                              label="Swift Number"
                              class="pt-0 currencyTitle"
                              placeholder="Enter Swift Number"
                              :value="swiftNumber"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-layout>
                    </v-flex>

                    <v-flex v-if="this.paymentMode == 'Cheque'" xs12 sm5 pb-3>
                      <v-text-field
                        label="Cheque No."
                        placeholder="Enter Cheque No."
                        v-model="cheque"
                        class="pt-0 currencyTitle"
                        :rules="[rules.required, rules.noWhiteSpace]"
                      />
                    </v-flex>

                    <v-flex
                      v-if="this.paymentMode == 'Demand Draft'"
                      xs12
                      sm5
                      pb-3
                    >
                      <v-text-field
                        label="Draft No."
                        placeholder="Enter Draft No."
                        class="pt-0 currencyTitle"
                        v-model="draftNo"
                        :rules="[rules.required, rules.noWhiteSpace]"
                      />
                    </v-flex>
                  </v-layout>

                  <v-layout
                    v-if="
                      this.paymentMode == 'Bank Transfer' &&
                      tabStatus === 'Driver'
                    "
                    class="physical-doc-payment-fields"
                  >
                    <v-flex md6 class="payadvance physical-doc-field-col">
                      <v-flex md12>
                        <v-text-field
                          v-model="accountHolderName"
                          label="Account Holder Name"
                          placeholder="Enter account holder name"
                          class="pt-0 currencyTitle"
                          :value="accountHolderName"
                          :rules="[rules.required, rules.noWhiteSpace]"
                        ></v-text-field>
                      </v-flex>

                      <v-layout>
                        <v-flex md12 class="payadvance">
                          <v-text-field
                            v-model="ifscCode"
                            label="IBAN Number"
                            placeholder="Enter IBAN number"
                            class="pt-0 currencyTitle"
                            :rules="[rules.required, rules.noWhiteSpace]"
                            maxlength="25"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex md6 class="payadvance physical-doc-field-col">
                      <v-layout>
                        <v-flex md12 class="payadvance">
                          <v-text-field
                            v-model="accountNumber"
                            label="Account Number"
                            placeholder=" Enter Account Number"
                            class="pt-0 currencyTitle"
                            :rules="[rules.required, rules.noWhiteSpace]"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout>
                        <v-layout>
                          <v-flex md12 class="payadvance">
                            <v-text-field
                              v-model="swiftNumber"
                              label="Swift Number"
                              class="pt-0 currencyTitle"
                              placeholder="Enter Swift Number"
                              :value="swiftNumber"
                              :rules="[rules.required, rules.noWhiteSpace]"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-layout>
                    </v-flex>
                  </v-layout>

                  <div class="physical-doc-datetime">
                    <v-menu
                      ref="FilterDateBool"
                      lazy
                      v-model="FilterDateBool"
                      class="date__icon"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      full-width
                      :nudge-right="40"
                      min-width="290px"
                      :return-value.sync="startDate"
                    >
                      <v-text-field
                        slot="activator"
                        label="Select Actual Date"
                        placeholder="Select Actual Date"
                        v-model="startDate"
                        prepend-icon="event"
                        readonly
                        class="pt-0 mt-0 currencyTitle physical-doc-pair-input"
                        :rules="[rules.required]"
                      ></v-text-field>
                      <v-date-picker
                        v-model="startDate"
                        :max="dateToday"
                        class="minHeight"
                        @change="$refs.FilterDateBool.save(startDate)"
                        no-title
                        scrollable
                      ></v-date-picker>
                    </v-menu>

                    <div class="physical-doc-time-wrap">
                      <v-text-field
                        label="Select Actual Time"
                        placeholder="HH:mm"
                        :value="actualTimeDisplay"
                        prepend-icon="access_time"
                        readonly
                        class="pt-0 mt-0 currencyTitle physical-doc-pair-input"
                        :rules="[rules.required]"
                      ></v-text-field>
                      <vue-timepicker
                        v-if="dialog"
                        class="fonttime physical-doc-time-overlay"
                        :minute-interval="30"
                        v-model="pickupTime"
                        input-width="100%"
                        placeholder="HH:mm"
                        close-on-complete
                        @change="onPickupTimeChange"
                      ></vue-timepicker>
                    </div>
                  </div>
                  <v-layout>
                    <v-flex xs12 md12 class="physical-doc-comments">
                      <v-text-field
                        :rules="[rules.required, rules.noWhiteSpace]"
                        class="pt-0 currencyTitle"
                        label="Comments"
                        placeholder="Comments"
                        v-model="Comments"
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>

              <deliveryProofListPopup
                v-if="tabStatus === 'Docs'"
                :assignmentId="this.assignDetails._id"
              />
            </div>

            <v-card-actions class="physical-doc-actions">
              <v-spacer></v-spacer>
              <v-btn
                class="physical-doc-no-btn"
                color="white darken-1"
                :disabled="processing"
                @click="close"
                >No</v-btn
              >
              <v-btn
                class="physical-doc-yes-btn"
                color="orange darken-2"
                dark
                :disabled="processing"
                @click="addProofOfDelivery()"
                >Yes</v-btn
              >
            </v-card-actions>
          </div>
        </v-card>
      </v-form>
    </v-dialog>
    <v-snackbar
      :timeout="3000"
      bottom
      color="red darken-2"
      v-model="x.error"
      class="white--text"
      v-if="x.error"
      >{{ x.error }}</v-snackbar
    >
    <!-- <success-dialog
      content="The proof of additional charge has been uploaded successfully"
      :show="x.success"
      :onclose="() => (x.success = false)"
    /> -->
  </div>
</template>

<script>
import moment from "moment";
import {
  addProofOfDelivery,
  uploadImage,
  editFinalPaymentDriverDetails,
} from "../../constants/api-urls";
import SuccessDialog from "@/components/Common/SuccessDialog";
import { StorageKeys } from "../../constants/constants";
import VueTimepicker from "vue2-timepicker/src/vue-timepicker.vue";
import deliveryProofListPopup from "../JobDocuments/deliveryProofListPopup.vue";
import { getOperatorRoleLabel } from "@/utils/shipmentLabels";

export default {
  data() {
    return {
      paymentMode: "Cash",
      dateToday: moment(new Date()).format("YYYY-MM-DD"),
      paymentType: null,
      accountHolderName: "",
      tabStatus: "Driver",
      swiftNumber: "",
      startDate: "",
      FilterDateBool: false,
      pickupTime: {
        HH: "",
        mm: "",
      },
      draftNo: "",
      accountNumber: "",
      ifscCode: "",
      advanceAmount: "",
      debtorPaymentMode: "Cash",
      banks: [],
      loading: false,
      cheque: "",
      draftNo: "",
      operationName: "",
      processing: false,
      advanceAmount: "",
      dialog: false,
      voucher: "",
      document: [],
      valid: true,
      lazy: false,
      documents: [],
      Comments: "",
      error: null,
      driverAmount: "",
      x: {
        error: null,
      },
      banks: [],
      bankName: "",
      rules: {
        required: (value) => !!value || "This field is required.",
        noWhiteSpace: (v) =>
          !v ||
          (typeof v === "string" && v.trim().length > 0) ||
          "Enter valid value.",
        amount: (v) =>
          /^\d*(\.\d+)?$/.test(v) || "Enter a valid amount. E.g 10 or 10.20",
        number: (v) => /^[0-9]*$/.test(v) || "Please enter valid amount",
      },
    };
  },
  props: {
    assignDetails: Object,
    section: String,
    driverCreditDuration: Number,
  },
  computed: {
    operatorRoleLabel() {
      return getOperatorRoleLabel(this.assignDetails && this.assignDetails.jobType);
    },
    actualTimeDisplay() {
      if (this.pickupTime && typeof this.pickupTime === "object") {
        if (this.pickupTime.HH && this.pickupTime.mm) {
          return `${this.pickupTime.HH}:${this.pickupTime.mm}`;
        }
        return "";
      }
      if (typeof this.pickupTime === "string" && this.pickupTime.trim()) {
        return this.pickupTime.trim();
      }
      return "";
    },
    formattedPickupTime() {
      return this.actualTimeDisplay;
    },
  },
  created() {
    // this.getActivityLog();
    this.customerStatus = localStorage.getItem("cust-status");
  },
  components: {
    SuccessDialog,
    VueTimepicker,
    deliveryProofListPopup,
  },
  methods: {
    parsePickupTime(time) {
      if (!time) {
        return { HH: "", mm: "" };
      }
      if (typeof time === "object") {
        return {
          HH: time.HH != null ? String(time.HH) : "",
          mm: time.mm != null ? String(time.mm) : "",
        };
      }
      const parts = String(time).trim().split(":");
      return {
        HH: parts[0] || "",
        mm: parts[1] ? parts[1].slice(0, 2) : "",
      };
    },
    onPickupTimeChange() {
      // Keep display/validation in sync after picking HH:mm from the overlay.
      this.pickupTime = this.parsePickupTime(this.pickupTime);
    },
    open() {
      this.dialog = true;
      this.paymentMode = this.assignDetails.creditorPaymentMode;
      this.ifscCode = this.assignDetails.creditorIBANNumber
        ? this.assignDetails.creditorIBANNumber
        : "";

      this.swiftNumber = this.assignDetails.creditorSwiftNo
        ? this.assignDetails.creditorSwiftNo
        : "";

      this.accountHolderName = this.assignDetails.creditorAccountHolderName
        ? this.assignDetails.creditorAccountHolderName
        : "";

      this.accountNumber = this.assignDetails.creditorAccountNumber
        ? this.assignDetails.creditorAccountNumber
        : "";

      this.Comments = this.assignDetails.commentForFinalPayment
        ? this.assignDetails.commentForFinalPayment
        : "";
      this.startDate = moment(this.assignDetails.actualRequestedDate).format(
        "YYYY-MM-DD"
      );
      if (this.assignDetails.actualRequestedTime) {
        this.pickupTime = this.parsePickupTime(
          this.assignDetails.actualRequestedTime
        );
      } else {
        const now = moment();
        const snappedMinute = now.minute() < 30 ? 0 : 30;
        this.pickupTime = {
          HH: now.clone().minute(snappedMinute).second(0).format("HH"),
          mm: now.clone().minute(snappedMinute).second(0).format("mm"),
        };
      }
    },
    goToProof(_id) {
      this.$router.push(`/documents/${_id}?type=Driver_Proof`);
    },
    removeImage(key) {
      this.document.splice(key, 1);
    },
    close() {
      this.dialog = false;
      this.document = [];
      this.processing = false;
      (this.type = ""), (this.comments = "");
      this.$refs.form.resetValidation();
      this.bankName = "";
      this.draftNo = "";
      this.paymentMode = "Cash";

      this.swiftNumber = "";
      this.cheque = "";
      this.voucher = "";
      this.ifscCode = "";
      this.accountHolderName = "";
      this.accountNumber = "";
      this.startDate = "";
      this.Comments = "";
      this.FilterDateBool = false;
      this.pickupTime = {
        HH: "",
        mm: "",
      };
    },
    uploadDocument(e) {
      this.x.error = null;
      var files = e.target.files || e.dataTransfer.files;
      let x = [...files];
      setTimeout(() => {
        this.$refs.fileUpload.value = "";
      }, 6000);
      if (!files.length) return;

      Array.from(x).forEach((y, i) => {
        this.createImage(files[i]);
      });
    },
    createImage(file) {
      let size = file.size / 1024 / 1024;
      // -------- FILE SIZE CHECK
      if (size > 5) {
        this.x.error = "Please upload proof with size less than 5MB!";

        return false;
      }
      if (
        file.type
          .toString()
          .substr(file.type.toString().lastIndexOf(".") + 1) !== "image/png" &&
        file.type
          .toString()
          .substr(file.type.toString().lastIndexOf(".") + 1) !== "image/jpg" &&
        file.type
          .toString()
          .substr(file.type.toString().lastIndexOf(".") + 1) !== "image/jpeg" &&
        file.type
          .toString()
          .substr(file.type.toString().lastIndexOf(".") + 1) !==
          "application/pdf"
      ) {
        this.x.error =
          "Please upload proof of file type png , jpg ,jpeg or pdf!";
        return false;
      } else {
        var image = new Image();
        var reader = new FileReader();
        var vm = this;

        reader.onload = (e) => {
          vm.image = e.target.result;
        };
        reader.readAsDataURL(file);
        this.upload(file);
      }
    },
    upload(file) {
      this.processing = true;
      const formData = new FormData();
      formData.append("image", file);
      this.axios({
        url: `${this.constants.apiUrl}${uploadImage}`,
        method: "POST",
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then(
        (response) => {
          this.processing = false;
          const { statusCode } = response.data;
          if (statusCode === 200) {
            if (this.document.length < 10) {
              this.document.push(response.data.data.original);
            } else {
              this.x.error = "Maximum 10 proofs can be uploaded!";
              return false;
            }
          } else {
            this.x.error = "Failed to upload image";
          }
          this.loading = false;
        },
        (error) => {
          this.x.error = "Failed to upload image";
          this.processing = false;
        }
      );
    },
    checkTime() {
      let re = /^\d{1,2}:\d{2}([ap]m)?$/;
      var time = this.formattedPickupTime;

      if (time != "" && !time.match(re)) {
        this.x.error = "Please select the valid time before moving ahead!";
        this.processing = false;
        return false;
      }
      return true;
    },
    addProofOfDelivery() {
      //this.processing = true;

      if (this.$refs.form.validate()) {
        this.processing = true;
        const selectedTime = this.formattedPickupTime;
        if (selectedTime) {
          if (this.checkTime() === false) {
            return false;
          }

          let currentDate = moment(new Date()).format("YYYY-MM-DD, HH:mm");
          let selectedDateTime = this.startDate + "," + selectedTime;

          if (
            new Date(currentDate).getTime() <
            new Date(selectedDateTime).getTime()
          ) {
            this.loading = false;
            this.processing = false;
            this.x.error =
              "Please select the past time and date before moving ahead!";
            return false;
          }
        }

        if (!this.Comments) {
          this.x.error = `Please enter comments in ${this.operatorRoleLabel.toLowerCase()} payment details`;
          this.processing = false;
          this.loading = false;
          return false;
        }
        //this.processing = true;
        let url = editFinalPaymentDriverDetails;
        delete this.axios.defaults.headers.common["token"];
        let token = localStorage.getItem(StorageKeys.SessionKey);
        let config = {
          headers: {
            authorization: `bearer ${token}`,
          },
        };
        let body = {
          assignmentId: this.assignDetails._id,
          //   paymentDocument: this.document,
          requestedDate: this.startDate,
          creditorPaymentMode: this.paymentMode.toString(),
          requestedTime: selectedTime,
          comment: this.Comments.trim(),
        };

        if (this.bankName) {
          body.bankName = this.bankName;
        }
        if (this.ifscCode) {
          body.creditorIBANNumber = this.ifscCode;
        }
        if (this.swiftNumber) {
          body.creditorSwiftNo = this.swiftNumber;
        }
        if (this.accountHolderName) {
          body.creditorAccountHolderName = this.accountHolderName;
        }
        if (this.accountNumber) {
          body.creditorAccountNumber = this.accountNumber;
        }

        if (this.document.length) {
          body.proof = this.document;
        }
        if (this.cheque && this.paymentMode === "Cheque") {
          body.creditorChequeNo = this.cheque;
        }
        if (this.draftNo && this.paymentMode === "Demand Draft") {
          body.creditorDraftNo = this.draftNo;
        }
        if (this.voucher && this.paymentMode === "Cash") {
          body.creditorVoucherNo = this.voucher;
        }
        this.axios.post(this.constants.apiUrl + url, body, config).then(
          (response) => {
            this.document = [];
            //this.$refs.fileUpload.value = "";
            this.processing = false;
            this.loading = false;
            this.close();

            this.$emit("ready-to-pay");
          },
          (error) => {
            this.processing = false;
            this.loading = false;
            this.x.error = error.response.data.message;
          }
        );
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.date__font .v-label {
  font-size: 13px !important;
}
</style>

<style scoped>
.break_long_text {
  word-break: break-all;
  word-break: break-word;
  hyphens: auto;
}
.user {
  padding: 10px;
}
.comments-view .v-toolbar {
  width: 100%;
  /* margin-left: 25%; */
}
.v-toolbar--fixed {
  position: inherit;
}
.assign-driver-btn {
  text-decoration: none;
  color: #ffffff;
  background-color: #bebebe;
  border: 2px solid grey;
  padding: 2px 5px;
  border-radius: 5px;
}
.document-link {
  text-decoration: none;
}
.ttt button select {
  border: none !important;
}
.imageClose {
  position: absolute;
  width: 15px;
  bottom: 80px;
  height: 15px;
  background: #000;
  border-radius: 50%;
  color: #fff !important;
  line-height: 15px;
  top: -6px;
  left: 2px;
}
.green-button {
  border-radius: 5px;
  background-color: #63ae63 !important;
  color: #ffffff !important;
  border: 2px solid green !important;
}

.assignment-list-ready-doc-btn {
  align-items: center;
  background: #ecfdf5 !important;
  border: 1px solid #a7f3d0 !important;
  border-radius: 6px !important;
  box-shadow: none !important;
  color: #047857 !important;
  display: inline-flex;
  font-family: inherit;
  font-size: 0.6875rem;
  font-weight: 700;
  height: auto !important;
  justify-content: center;
  letter-spacing: 0;
  line-height: 1.1;
  min-height: 1.5rem !important;
  min-width: max-content !important;
  padding: 0.1875rem 0.5rem !important;
  text-align: center;
  text-transform: none;
  white-space: nowrap !important;
  width: auto !important;
}

.message {
  display: inline-block;
  margin: 0 50px;
}
.communication {
  width: 40%;
}
.success {
  font-size: 18px;
  font-weight: 600;
}
.messagebtn {
  margin: 0 auto;
}
.list {
  display: inline-block;
  position: relative;
}
.thumb {
  width: 80px;
  height: 80px;
}

.custom-file-upload {
  border: none;
  display: inline-block;
  background: #ea7a1c;
  font-size: 16px;
  color: #fff;
  padding: 10px 12px;
  cursor: pointer;
}

.vue__time-picker input.display-time {
  border-radius: 0px !important;
  border-bottom: 1px solid #d2d2d2 !important;
  border: none;
  padding: 0px !important;
}

.physical-doc-payment-summary {
  display: grid !important;
  gap: 0.5rem;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin-bottom: 0.5rem;
}

.physical-doc-payment-summary__item {
  background: #fafafa;
  border: 1px solid #eeeeee;
  border-radius: 0.5rem;
  box-sizing: border-box;
  max-width: none !important;
  min-width: 0;
  padding: 0.375rem 0.625rem !important;
  width: auto !important;
}

.physical-doc-payment-summary__item .sub-heading {
  display: flex;
  flex-direction: column;
  font-size: 0.6875rem;
  gap: 0.125rem;
  line-height: 1.25;
  min-width: 0;
}

.physical-doc-payment-summary__item .heading {
  font-size: 0.875rem;
  overflow-wrap: anywhere;
}

.physical-doc-tabs {
  margin-bottom: 0.25rem;
}

.physical-doc-tabs ::v-deep .v-tabs__container {
  height: auto !important;
  min-height: 2.25rem;
}

.physical-doc-tabs ::v-deep .v-tabs__item {
  box-sizing: border-box;
  height: auto !important;
  line-height: 1.3;
  min-height: 2.25rem;
  padding: 0.375rem 0.75rem;
  white-space: normal;
}

.physical-doc-datetime {
  align-items: start;
  display: grid;
  gap: 0.25rem 1.25rem;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  margin: 0.25rem 0;
  width: 100%;
}

.physical-doc-pair-input {
  margin: 0 !important;
  padding-top: 0 !important;
}

.physical-doc-datetime ::v-deep .v-input,
.physical-doc-datetime ::v-deep .v-text-field {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

.physical-doc-datetime ::v-deep .v-input__prepend-outer {
  align-self: flex-start;
  margin: 0.35rem 0.5rem 0 0 !important;
}

.physical-doc-datetime ::v-deep .v-input__control,
.physical-doc-datetime ::v-deep .v-input__slot {
  margin: 0 !important;
}

.physical-doc-datetime ::v-deep .v-text-field__details,
.physical-doc-payment-fields ::v-deep .v-text-field__details {
  display: block !important;
  margin-top: 0.125rem !important;
  min-height: 1rem;
  opacity: 1 !important;
  padding-top: 0 !important;
}

.physical-doc-datetime ::v-deep .v-messages__message,
.physical-doc-payment-fields ::v-deep .v-messages__message {
  -webkit-text-fill-color: #d32f2f !important;
  color: #d32f2f !important;
  font-size: 0.75rem !important;
  font-weight: 700 !important;
  line-height: 1.3 !important;
  opacity: 1 !important;
  visibility: visible !important;
}

.physical-doc-time-wrap {
  overflow: visible;
  position: relative;
  z-index: 6;
}

.physical-doc-time-overlay {
  bottom: auto;
  height: 2.75rem;
  left: 2.25rem;
  overflow: visible !important;
  pointer-events: auto;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 7;
}

.physical-doc-time-overlay ::v-deep input.display-time,
.physical-doc-time-overlay ::v-deep input.display-time::placeholder {
  -webkit-text-fill-color: transparent !important;
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
  caret-color: transparent !important;
  color: transparent !important;
  cursor: pointer;
  font-size: 0 !important;
  height: 100% !important;
  margin: 0 !important;
  opacity: 0 !important;
  outline: none !important;
  padding: 0 !important;
  pointer-events: auto !important;
  text-shadow: none !important;
  width: 100% !important;
}

.physical-doc-time-overlay ::v-deep .dropdown {
  left: 0;
  top: calc(100% + 0.15rem);
  z-index: 30 !important;
}

.fonttime {
  font-size: 12px !important;
}

.fonttime ::v-deep .dropdown.drop-down {
  top: 100%;
}
.label__position {
  position: relative;
  top: 5px;
}

@media (max-width: 40rem) {
  .physical-doc-payment-summary {
    grid-template-columns: 1fr;
  }

  .physical-doc-datetime {
    gap: 0.75rem;
    grid-template-columns: 1fr;
  }

  .physical-doc-tabs ::v-deep .v-tabs__container {
    flex-direction: column;
  }
}

.physical-doc-header {
  align-items: center;
  background:
    radial-gradient(circle at 100% 0%, rgba(245, 130, 32, 0.14), transparent 42%),
    linear-gradient(135deg, #fff7ed 0%, #ffffff 55%, #f4f7fb 100%);
  border-bottom: 0.0625rem solid #fed7aa;
  display: flex;
  gap: 0.75rem;
  justify-content: space-between;
  padding: 0.5rem 0.75rem 0.5rem 1rem;
}

.physical-doc-header__brand {
  align-items: center;
  display: flex;
  gap: 0.7rem;
  min-width: 0;
}

.physical-doc-header__badge {
  align-items: center;
  background: linear-gradient(160deg, #1c2b5f 0%, #2a3f7a 100%);
  border-radius: 0.7rem;
  box-shadow: 0 0.35rem 0.75rem rgba(28, 43, 95, 0.22);
  display: inline-flex;
  flex: 0 0 auto;
  height: 2rem;
  justify-content: center;
  width: 2rem;
}

.physical-doc-header__badge .v-icon {
  color: #ffffff !important;
  font-size: 1.05rem !important;
}

.physical-doc-title {
  color: #1c2b5f;
  font-size: 0.975rem;
  font-weight: 800;
  letter-spacing: -0.01em;
  line-height: 1.3;
  margin: 0;
}

.physical-doc-close {
  color: #74716a !important;
  height: 2rem !important;
  margin: 0 !important;
  width: 2rem !important;
}

.physical-doc-close .v-icon {
  color: #74716a !important;
}

.physical-doc-body {
  max-height: min(82vh, 46rem);
  overflow-x: hidden;
  overflow-y: auto;
  padding-bottom: 0;
  scrollbar-width: thin;
}

.physical-doc-content {
  padding: 0.75rem 1rem 0.25rem !important;
}

.physical-doc-content ::v-deep .v-input--radio-group {
  margin-bottom: 0.25rem;
}

.physical-doc-content ::v-deep .v-input--radio-group .v-messages {
  min-height: 0;
}

.physical-doc-credit {
  background: #fffaf4;
  border: 0.0625rem solid #fed7aa;
  border-radius: 0.65rem;
  color: #8a857c;
  font-size: 0.8125rem;
  font-weight: 700;
  margin: 0.5rem 0 0.625rem;
  padding: 0.375rem 0.75rem;
}

.physical-doc-credit strong {
  color: #1c2b5f;
  font-weight: 800;
}

.physical-doc-payment-fields {
  display: flex !important;
  flex-wrap: wrap;
  gap: 0 1.25rem;
  margin: 0 !important;
  width: 100%;
}

.physical-doc-field-col {
  flex: 1 1 16rem !important;
  max-width: calc(50% - 0.625rem) !important;
  min-width: 0 !important;
  padding-bottom: 0 !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.physical-doc-actions {
  background: #fffaf4 !important;
  border-top: 0.0625rem solid #fed7aa;
  bottom: 0;
  gap: 0.5rem;
  padding: 0.5rem 1rem !important;
  position: sticky;
  z-index: 2;
}

.physical-doc-comments {
  padding-top: 0;
}
</style>

<style src="../../styles/physical-doc-dialog.css"></style>
